import { Pipe, PipeTransform } from '@angular/core';
import { SensorDetailDto } from '@artemis-software/wr-api';
import SensorMetricKindEnum = SensorDetailDto.SensorMetricKindEnum;

@Pipe({
  standalone: false,
  name: 'sensorMetricKind'
})
export class SensorMetricKindPipe implements PipeTransform {
  transform(value: SensorMetricKindEnum | undefined | null): string {
    switch (value) {
      case SensorMetricKindEnum.Gauge:
        return 'Punktwert';
      case SensorMetricKindEnum.Cumulative:
        return 'Kumulativ';
      case SensorMetricKindEnum.Delta:
        return 'Differenz';
    }
    return 'k.A.';
  }
}
